<template>
	<div v-if="blok && blok.typeform_id" :id="formId" class="mt-md">
		<v-typeform :form-id="blok.typeform_id" :button-text="blok.button_text" />
	</div>
</template>

<script setup lang="ts">
import type {BlokComponent} from "@pkg/shared/types";

const properties = defineProps<{
	blok: Extract<BlokComponent, {component: "sb-typeform"}>;
}>();

const formId = computed(() => properties.blok.anchor_id ?? "");
</script>
